'use strict';

import React from 'react';
import {SubMenu} from 'components/base/SubMenu';
import {Link} from 'react-router';

import utils from 'services/utils';

import 'styles/PageTitle.scss';


class PageTitle extends React.Component {
    static defaultProps = {
        selectable: false,
    };

    state = {
        isVisible: false,
    };

    show = (event) => {
        utils.preventDefault(event);

        this.setState({
            isVisible: true,
        });
        document.addEventListener("click", this.hide);
    };

    componentWillUnmount() {
        document.removeEventListener("click", this.hide);
    }

    hide = () => {
        this.setState({
            isVisible: false,
        });
        document.removeEventListener("click", this.hide);
    };

    render() {
        var selectable = this.props.selectable;

        var styles = {
            cursor: selectable ? 'pointer' : 'auto',
        };

        var subTitle = null;

        if (this.props.subTitle) {
            if (this.props.subTitle.link) {
                subTitle = (
                    <span className="sub-title">
                        <Link to={this.props.subTitle.link}>{this.props.subTitle.text}</Link>
                    </span>
                );
            } else {
                subTitle = <span className="sub-title">{this.props.subTitle.text}</span>;
            }
        }

        return (
            <div id="page-title">
                <h3 className={selectable ? 'selectable' : ''} style={styles} onClick={this.show}>
                    {subTitle}
                    {this.props.title} {selectable ? <i className="arrow-down-large" /> : ''}
                </h3>
                {selectable ? (
                    <SubMenu visible={this.state.isVisible}>
                        {this.props.subMenu.props.children}
                    </SubMenu>
                ) : ''}
            </div>
        );
    }
}

export default PageTitle; 
